import { createFileRoute } from '@tanstack/react-router'

import { cardFilters } from '@/features/cards/card-filters'
import { CardsPage } from '@/features/cards/cards-page'

export const Route = createFileRoute('/_app/cards/')({
    validateSearch: cardFilters.parse,
    component: CardsPage,
    staticData: { crumb: 'Cards' }
})
